import { defineComponent as _defineComponent } from 'vue'

import { ref, computed } from 'vue';

import { useStore } from '@store';

import NavDropdown from './NavDropdown.vue';

/** ... */
const THEME_OPTIONS: ZephyrWeb.OptionItem<ZephyrWeb.AppTheme>[] = [
  { text: 'Light', value: 'light' },
  { text: 'Dark', value: 'dark' },
  { text: 'Auto', value: 'auto' },
];

export default /*#__PURE__*/_defineComponent({
  __name: 'AppearanceDropdown',
  setup(__props, { expose }) {

const store = useStore();

const dropdown = ref<InstanceType<typeof NavDropdown> | null>(null);

const theme = computed({
  get: () => store.state.theme,
  set: (value) => store.commit('SET_THEME', { theme: value }),
});

/**
 * ...
 */
function toggle() {
  dropdown?.value?.toggle();
}

expose({ toggle });

return { __sfc: true,THEME_OPTIONS, store, dropdown, theme, toggle, NavDropdown }
}

})